import {MC_2_0_PLANS} from './constants'

// FULSAS-14889: T&C disclaimer per TGP plan and billing term.
// All texts are PLACEHOLDERS, replace with the final copy from Legal
// (BUSREQ-15743). Plain strings: the payment forms render `disclaimerText`
// as text, not HTML.
const StarterDisclaimer = `Your Thryv Software Subscription Period is either month-to-month (when billed monthly), or 12 months (when billed annually). Subscription Services have a 6-month initial term (billed monthly) unless stated otherwise in their product-specific terms. Some Subscription Services also carry a per-user fee that varies by user count, where applicable.`
const SignatureDisclaimer = `Your Thryv Software Subscription Period is either an initial 6 months (when billed monthly), or 12 months (when billed annually). Add-on Subscription Services have a 6-month initial term (billed monthly) unless stated otherwise in their product-specific terms. Some Subscription Services also carry a per-user fee that varies by user count, where applicable.`
export const TGP_DISCLAIMERS = {
  starterM2M: StarterDisclaimer,
  starterAnnual: StarterDisclaimer,
  signatureM2M: SignatureDisclaimer,
  signatureAnnual: SignatureDisclaimer,
  signaturePlusM2M: SignatureDisclaimer,
  signaturePlusAnnual: SignatureDisclaimer,
  // Any other MC_2_0_PLANS code (e.g. Premier) with no tier-specific copy.
  default: '',
}

// Plan code -> disclaimer. mc_prov2 is the M2M Signature plan code.
const TGP_DISCLAIMER_BY_CODE = {
  'mc_starter-5-thryv-m2m': TGP_DISCLAIMERS.starterM2M,
  'starter-5-thryv-annual': TGP_DISCLAIMERS.starterAnnual,
  'mc_prov2-5-thryv-m2m': TGP_DISCLAIMERS.signatureM2M,
  'signature-5-thryv-annual': TGP_DISCLAIMERS.signatureAnnual,
  'signature_plus-5-thryv-m2m': TGP_DISCLAIMERS.signaturePlusM2M,
  'signature_plus-5-thryv-annual': TGP_DISCLAIMERS.signaturePlusAnnual,
}

export const hasTgpPlan = (items = []) =>
  items.some(item => MC_2_0_PLANS.includes(item?.code))

// Disclaimer for the TGP plan in the cart, or null when there is none.
// If several TGP plans are present, the first one in `items` wins.
export const getTgpDisclaimer = (items = []) => {
  const plan = items.find(item => MC_2_0_PLANS.includes(item?.code))
  if (!plan) return null
  return TGP_DISCLAIMER_BY_CODE[plan.code] ?? TGP_DISCLAIMERS.default
}

// TGP carts get their plan-specific disclaimer; everything else keeps the
// caller's existing (non-TGP) text.
export const getSubscriptionDisclaimer = ({items, nonTgpDisclaimer}) =>
  getTgpDisclaimer(items) ?? nonTgpDisclaimer
